import { dynamicPx, flexColumn, TextTypography } from 'components/common/Common';
import Table from 'components/table/Table';
import React from 'react';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';
import { BlurBackgroundName, CenterContent, contentWidth, InfoIcon } from '../JetSale.style';

const InfoBackground = styled.section`
  background: #eff6fa;
  display: flex;
  justify-content: center;
  width: 100vw;
  margin-top: ${dynamicPx({ minSize: 40, maxSize: 120 })};
`;

const InfoSection = styled.section`
  background: #eff6fa;
  display: flex;
  padding: ${dynamicPx({ minSize: 16, maxSize: 80 })} 0;
  flex-wrap: wrap;
  ${contentWidth}
  ${flexGap('2.5em')}
`;
const InfoContainer = styled.article`
  ${flexColumn}
  ${flexGap('1em')}
  flex: 1;
`;

const BlurBackgroundTitle = styled(BlurBackgroundName)`
  padding: 0.5em 1.5em;
  background: rgba(7, 19, 33, 0.08);
  border-radius: 2.0625em;
  white-space: nowrap;
`;

const Title = styled(CenterContent)`
  margin: ${dynamicPx({ minSize: 16, maxSize: 40 })} 0 !important;
`;

const AircraftTable = ({ data, header, category }) => {
  const isHeavyJet = category === 'heavyJets';
  return (
    <>
      <Title as="div">
        <InfoIcon
          $dynamicSize={{ minSize: isHeavyJet ? 223 : 322, maxSize: isHeavyJet ? 494 : 861 }}
          $autoHeight
        >
          <img
            src={`/imgs/webp/jetSale/${isHeavyJet ? 'text3' : 'text4'}.webp`}
            alt={
              isHeavyJet
                ? 'Heavy Jet Models & Prices'
                : 'Midsize  to Super Midsize Jet Models & Prices'
            }
          />
        </InfoIcon>
      </Title>

      <Table header={header} data={data} />

      <InfoBackground>
        <InfoSection>
          <InfoContainer>
            <BlurBackgroundTitle>
              <TextTypography fontWeight={700}>Endurance</TextTypography>
            </BlurBackgroundTitle>
            <TextTypography step={-1}>
              Aircraft endurance approximations are based on zero wind, ISA conditions, no runway or
              temperature restrictions, and two passengers at long-range cruise speed.
            </TextTypography>
          </InfoContainer>
          <InfoContainer>
            <BlurBackgroundTitle>
              <TextTypography fontWeight={700}>All of the prices are rough prices</TextTypography>
            </BlurBackgroundTitle>
            <TextTypography step={-1}>
              The final prices for new models are based on the final equipment of the aircraft. The
              pre-owned prices are based on flight hours, the year of manufacturing, the conditions
              and the owner’s decision, etc.
            </TextTypography>
          </InfoContainer>
        </InfoSection>
      </InfoBackground>
    </>
  );
};

export default AircraftTable;
